/**
 * Default width for long-text columns when the column def omits `width`.
 * String so it stays responsive (`min()`), or set `width` on the column to override.
 */
export const DEFAULT_LONG_TEXT_COLUMN_WIDTH = "min(11rem, 20vw)";

/**
 * Column keys whose body text should be left-aligned, wrapped, with centered headers.
 * `cellAlign` / `headerAlign` / `wrap: false` on the column def override this behavior.
 */
const LONG_TEXT_KEYS = new Set([
  "address",
  "requestedAddress",
  "requestedEmail",
  "remarks",
  "remark",
  "adminRemarks",
  "description",
  "title",
  "message",
  "messageBody",
  "responseDescription",
  "comments",
]);

/**
 * @param {Object} col – column definition from `Table` `columns` prop
 * @returns {{ cellAlign: string, headerAlign: string, wrap: boolean, width: string|number|undefined }}
 */
export function resolveColumnPresentation(col) {
  const isLongTextKey = LONG_TEXT_KEYS.has(col.key);
  const defaultAlign = col.align ?? "center";

  const cellAlign = col.cellAlign ?? (isLongTextKey ? "left" : defaultAlign);
  const headerAlign = col.headerAlign ?? (isLongTextKey ? "center" : defaultAlign);
  const wrap = isLongTextKey ? col.wrap !== false : col.wrap === true;
  const width =
    col.width != null ? col.width : isLongTextKey ? DEFAULT_LONG_TEXT_COLUMN_WIDTH : undefined;

  return { cellAlign, headerAlign, wrap, width };
}
